import { MailOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { pathOr, replace } from 'ramda';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PasswordInput from './PasswordInput';

const EmailPasswordForm = ({
  emailValue,
  emailDisabled,
  setValue,
  fieldIsDefined,
  emailIsValid,
  passwordIsValid,
  isSignIn
}) => {
  const [password, setPassword] = useState('');
  const handlePasswordChange = (e) => {
    const cleanedValue = replace(/\s/g, '', pathOr('', ['target', 'value'], e));
    setPassword(cleanedValue);
    setValue('password', cleanedValue);
  };
  const displayErrorMsgEmail = !isSignIn && fieldIsDefined('email') && !emailIsValid;
  return (
    <>
      <div className="flex flex-col">
        <label>E-mail</label>
        <Input
          prefix={<MailOutlined />}
          placeholder="E-mail"
          value={emailValue}
          disabled={emailDisabled}
          onChange={(e) => setValue('email', pathOr('', ['target', 'value'], e))}
          size="middle"
          status={displayErrorMsgEmail ? 'error' : ''}
        />
        {displayErrorMsgEmail && (
          <div className="text-regular my-1 text-flexi-red">
            {'L\'email saisi n\'est pas valide.'}
          </div>
        )}
      </div>

      <div className="flex flex-col mt-4">
        <label>Mot de passe</label>
        <PasswordInput
          placeholder="Votre mot de passe"
          password={password}
          onChange={handlePasswordChange}
          isValid={isSignIn || passwordIsValid}
        />
        {isSignIn && <Link to="/account/resetpasswordrequest" className="text-xs mt-2 underline text-flexi-grey">Mot de passe oublié</Link>}
      </div>
    </>
  );
};

export default EmailPasswordForm;
